class Controller {
  constructor($injector, $stateParams, Sections) {
    this.$injector = $injector;
    this.$stateParams = $stateParams;
    this.Events = $injector.get("Events");

    this.activeParams = this.$stateParams;
    this.sections = Sections.settingsSections;
    this.page = this.$stateParams.page;
    this.limit = this.$stateParams.limit;
    this.paginateEvent = this.Events.getPaginateEvent("privateBusRequests");
    this.filterEvent = this.Events.getFilterEvent("privateBusRequests");
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/privateBusRequests/privateBusRequests.controller.js